import { toast } from 'react-toastify';
import * as Sentry from "@sentry/react";

const API_BASE_URL = '/smallgoodstuff/wp-json/availability-calendar/v1/holidaydays';
const FRONT_API_BASE_URL = '/smallgoodstuff/wp-json/availability-calendar/v1/listingholidaydays';
const LISTING_NAME = (window as any).availabilityCalSettings.listingName;

export const holidayDaysApiPost = async (day: string, status: string): Promise<void> => {

    const toastId = toast.loading("Updating day...", {
        position: "top-center",
        theme: "colored"
    });

    // Add 'beforeunload' event listener
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
        // Set the warning return value
        event.preventDefault();
        event.returnValue = ''; // Modern browsers ignore the string, but this is necessary for backward compatibility
    };

    try {
        const response = await fetch(API_BASE_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': (window as any).availabilityCalSettings.nonce
            },
            body: JSON.stringify({ day, status })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        toast.update(toastId, {
            render: "Day successfully updated",
            type: "success",
            isLoading: false,
            autoClose: 2000,
            hideProgressBar: true,
            theme: "colored"
        });
    } catch (error) {
        toast.update(toastId, {
            render: "Error updating day",
            type: "error",
            isLoading: false,
            autoClose: 4000,
            hideProgressBar: true,
            theme: "colored"
        });
        Sentry.captureException(error);
    } finally {
        // Remove 'beforeunload' event listener
        window.removeEventListener('beforeunload', handleBeforeUnload);
    }
};

export const holidayDaysApiDelete = async (days: string[], context: string): Promise<void> => {
    try {
        const response = await fetch(API_BASE_URL, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': (window as any).availabilityCalSettings.nonce
            },
            body: JSON.stringify({ days })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        if (context != 'settings') {
            toast.success('All days successfully updated', {
                position: "top-center",
                autoClose: 2000,
                hideProgressBar: true,
                theme: "colored"
            });
        }
    } catch (error) {
        toast.error('Error updating all days', {
            position: "top-center",
            autoClose: 4000,
            hideProgressBar: true,
            theme: "colored"
        });
        Sentry.captureException(error);
    }
};

export const holidayDaysApiGet = async () => {

    try {
        const response = await fetch(API_BASE_URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': (window as any).availabilityCalSettings.nonce
            },
        });

        if (!response.ok) {
            throw new Error('Failed to fetch working days');
        }

        return await response.json();
    }  catch (error) {
        toast.error('Error loading working days, please reload the page.', {
            position: "top-center",
            autoClose: 4000,
            hideProgressBar: true,
            theme: "colored"
        });
        Sentry.captureException(error);
    }
};

export const holidayDaysFrontApiGet = async () => {

    try {
        const response = await fetch(`${FRONT_API_BASE_URL}?listing-name=${LISTING_NAME}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': (window as any).availabilityCalSettings.nonce
            },
        });

        if (!response.ok) {
            throw new Error('Failed to fetch working days');
        }

        return await response.json();
    }  catch (error) {
        toast.error('Error loading working days, please reload the page.', {
            position: "top-center",
            autoClose: 4000,
            hideProgressBar: true,
            theme: "colored"
        });
        Sentry.captureException(error);
    }
};